import { createAction } from '@ngrx/store';

export const websocketConnected = createAction(
  '[Websocket] Connected'
);

export const websocketDisconnected = createAction(
  '[Websocket] Disconnected'
);
